import Button from "@app/sharedComponents/Button/Button"
import { ThemedText, ThemedView } from "@app/theme"

const UserPayConfirmation =({closeBottomSheet})=>{
    return(
        <ThemedView p="lg" backgroundColor="bg-surface-primary">
            <ThemedText variant="h5s" color="text-primary" mb="lg">
                Thank you for the confirmation
            </ThemedText>
            <ThemedText variant="b3r" color="text-secondary" mb="lg" mt="sm">
                We are currently checking the latest status with lender, interest status will be updated once we receive their response.
            </ThemedText>
            <ThemedText variant="b4s" color="text-secondary" mb="sm">
                Note
            </ThemedText>
            <ThemedView  flexDirection="row"  borderRadius="sm" alignItems="baseline" mb="sm"> 
                <ThemedView backgroundColor="border-primary" height={6} width={6} borderRadius="full" mr="sm" mb="2xs" />
                <ThemedText variant="b4r" color="text-secondary">
                    It may take upto 2-3 business days to confirm the payment status with the lender.
                </ThemedText>
            </ThemedView>
            <ThemedView  flexDirection="row"  borderRadius="sm" mb="2xl" alignItems="baseline"> 
                <ThemedView backgroundColor="border-primary" height={6} width={6} borderRadius="full" mr="sm"  mb="2xs"/>
                <ThemedText  variant="b4r" color="text-secondary">
                Payment deducted via auto-debit accounted as paid on the due date
                </ThemedText>
            </ThemedView>
            <Button label="Ok, got it!" handlePress={closeBottomSheet}/>
        </ThemedView>
    )
}

export default UserPayConfirmation